import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import ShipmentPieceSticker from './ShipmentPieceSticker';

export default function ShipmentPiecesStickersWindow({
  open,
  onClose,
  pieces,
  lockedShipmentId = null,
  embeddedOnly = false,
}) {
  const { t } = useTranslation('ui');

  return (
    <React.Fragment>
      <Modal open={open} onClose={onClose}>
        <ModalDialog variant="outlined" role="alertdialog">
          <DialogTitle>
            <SubtitlesIcon />
            {t('shipmentPieces.stickersWindowTitle')}
          </DialogTitle>
          <Divider />
          <ShipmentPieceSticker
            pieces={pieces}
            lockedShipmentId={lockedShipmentId}
            embeddedOnly={embeddedOnly}
          />
          <DialogActions>
            <Button variant="plain" color="neutral" onClick={onClose}>
              {t('actions.close')}
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}
